module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiExtIt.e04b1d5.woff";